
import {
  Box,
  CSSObject,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  Theme,
  Typography,
  useTheme
} from '@mui/material';
import { NavBarItem } from 'modules/components/layer01';
import logoFull from '../../../../assets/logo/logoFull.svg';

import { ReactComponent as LogoIcon } from '../../../../assets/logo/logoIcon.svg';

import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';



export type NavBarProps = {
  workSpaceItems: NavBarItem.INavBarItem[];
  settingsItems?: NavBarItem.INavBarItem[];
  projectName?: string;
  bottomBottom?: {
    label: string;
    icon: ReactNode;
    path: string;
    onClick: () => void;
  };

};
const drawerWidth = '12.3rem';

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  overflowX: 'hidden',
  backgroundColor: theme.palette.background.default,
  borderRight: '0px solid transparent'
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(8)} + 7px)`,
  height: '100vh',
  backgroundColor: theme.palette.background.default,

  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 7px)`,
    height: '100vh'
  }
});

const LogOutMixin = (): CSSObject => ({
  bottom: 'calc(.5vh)'
});

export type NavBarItem = {
  label: string;
  path?: string;
  icon: ReactNode;
};

export const FC = (props: NavBarProps) => {
  const theme = useTheme();
  const [
    showNav,
    setShowNav
  ] = React.useState(true);

  const location = useLocation();

  return (
    <Drawer
      variant='permanent'
      open={showNav}
      sx={{
        flexShrink: 0,
        ...(showNav && {
          ...openedMixin(theme),
          '& .MuiDrawer-paper': {
            ...openedMixin(theme),
            height: '-webkit-fill-available'
          }
        }),
        ...(!showNav && {
          ...closedMixin(theme),
          '& .MuiDrawer-paper': closedMixin(theme)
        })
      }}
      onClick={() => setShowNav((prev) => !prev)}
      // onMouseLeave={() => setShowNav(() => false)}
    >
      <List
        sx={{
          width: showNav
            ? '16.5rem'
            : '10px',
          height: '100vh',
          backgroundColor: theme.palette.background.default
        }}
      >
        <ListItem>
          <ListItemIcon>
            {showNav
              ? (
                <Box
                  display='flex'
                  flexDirection='column'
                  marginLeft='1rem'
                >
                  <Box
                    component='img'
                    src={logoFull}
                    width='10.375rem'
                    height='2.5rem'
                  />
                  <Typography
                    textAlign='center'
                    variant='selectedNavItemText'
                    color={theme.palette.customGray.darker}
                  >
                    {props.projectName}
                  </Typography>
                </Box>
              )
              : (

                <Box
                  paddingLeft='.40rem'
                >

                  <LogoIcon />
                </Box>



              )}
          </ListItemIcon>


        </ListItem>
        <ListItem>
        </ListItem>

        <Box paddingTop={3}>

          <Box
            paddingTop={0}
            paddingLeft={0}
            paddingRight={2.5}
          >
            {props.workSpaceItems.map((item, i) => (
              <NavBarItem.FC
                key={i}
                label={item.label}
                icon={item.icon}
                path={item.path}
                isSelected={location.pathname.includes(item.path ?? '') ? true : false}
              />
            ))}
          </Box>
        </Box>

        <Box
          paddingLeft={0}
          paddingRight={2.5}
        >

          {props.settingsItems?.map((item, i) => (
            <NavBarItem.FC
              key={i}
              label={item.label}
              icon={item.icon}
              path={item.path}
            />
          ))}
        </Box>

        <Box
          position='absolute'
          onClick={(e) => {
            e.stopPropagation();
            props.bottomBottom?.onClick();
          }}
          sx={LogOutMixin()}
        >
          <NavBarItem.FC
            label={
              showNav
                ? props.bottomBottom?.label ?? ''
                : ''
            }
            icon={props.bottomBottom?.icon ?? <></>}
            path={props.bottomBottom?.path}
            onClick={() => props.bottomBottom?.onClick()}
            isButton={true}

          />
        </Box>
      </List>
    </Drawer>
  );
};

